<template>
<div class="teammatesGrid-cell"> 
    <img :src="card.imageUrl" class="teammatesGrid-cell-image"/>
    <div class="teammatesGrid-cell-inner">
        <h3 class="hdg hdg_3 vr_2">{{card.heading}}<template v-if="card.jobTitle">,</template> {{card.jobTitle}}</h3>
        <div class="vr_4">{{card.location}}</div>
        <div class="vr_4">{{card.description}}</div>
        <a :href="card.link" class="iconCta">
            <div class="iconCta-text">Read More</div>
            <div class="iconCta-icon">
                <i class="icon icon_chevron icon_chevron"></i>
            </div>
        </a>
    </div>
</div>
</template>

<script>
export default {
    props: ['card', 'index'],
} 
</script>
